import { styled } from "@mui/material";

export const LoaderWrapper = styled("div")({
  position: "absolute",
  zIndex: 9999,
  top: "45%",
  right: "47%",

  span: {
    width: "70px !important",
    height: "70px !important",
  },
});
